var React = require('react');

function IconChipClose (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":".Close Base"},React.createElement("path",{"id":"Path","fillRule":"evenodd","clipRule":"evenodd","d":"M10 10L2 2L10 10ZM10 2L2 10L10 2Z","stroke":"#A1AAC5","strokeWidth":"1.125","strokeLinecap":"round","strokeLinejoin":"round"})));
}

IconChipClose.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = IconChipClose;

IconChipClose.default = IconChipClose;
